import { useEffect, useState } from 'react'
import { useQuickKeysManager } from '../../ng-compat/hooks'
import { buildQuickKeysLayout } from '../../quick-keys/qk-layout'
import { QuickKeyRoot } from '../../quick-keys/qk-types'

export const useQuickKeysLayout = () => {
  const quickKeysManager = useQuickKeysManager()
  const [layout, setLayout] = useState<QuickKeyRoot | null>(null)
  useEffect(() => {
    const set = () => {
      const data = quickKeysManager.quickKeyLayout
      if (data) {
        const newLayout = buildQuickKeysLayout(data)
        setLayout(newLayout)
      } else {
        setLayout(null)
      }
    }
    quickKeysManager.init().then(set)

    quickKeysManager.on('quickKeyLayoutChange', set)

    return () => {
      quickKeysManager.off('quickKeyLayoutChange', set)
    }
  }, [quickKeysManager])

  return layout
}
